import { defineAsyncComponent } from 'vue'
export default {
  admin: defineAsyncComponent(() => import("/builds/namicomi/frontend/layouts/admin.vue").then(m => m.default || m)),
  conversations: defineAsyncComponent(() => import("/builds/namicomi/frontend/layouts/conversations.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/builds/namicomi/frontend/layouts/default.vue").then(m => m.default || m)),
  embed: defineAsyncComponent(() => import("/builds/namicomi/frontend/layouts/embed.vue").then(m => m.default || m)),
  feed: defineAsyncComponent(() => import("/builds/namicomi/frontend/layouts/feed.vue").then(m => m.default || m)),
  studio: defineAsyncComponent(() => import("/builds/namicomi/frontend/layouts/studio.vue").then(m => m.default || m))
}